module.exports = __webpack_public_path__ + "static/media/快速涂鸦识别.7070a6eb.png";